import { render } from "./addModuleTerminal.vue?vue&type=template&id=2e20377c"
import script from "./addModuleTerminal.vue?vue&type=script&lang=js"
export * from "./addModuleTerminal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__